import { render, staticRenderFns } from "./RBAC.vue?vue&type=template&id=94643690&scoped=true"
import script from "./RBAC.vue?vue&type=script&lang=js"
export * from "./RBAC.vue?vue&type=script&lang=js"
import style0 from "./RBAC.vue?vue&type=style&index=0&id=94643690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94643690",
  null
  
)

export default component.exports